import React from 'react';
import { splitNumber } from "../../../utils/utility";

import './OtherTraffic.css';

export default function OtherTraffic(props) {
  const fontSize = (props.total > 100000 || props.unique > 100000) ? '52px' : '62px';
  return (<div className="summary other-traffic light-grey-border">
    <div className="other-traffic-title"><strong>{props.title || 'Other Traffic'}</strong></div>
    <div className="other-traffic-content">
      <div className="other-traffic-total">
        <div className="other-traffic-subtitle">{props.totalTitle || 'Total Other'}</div>
        <div className="blue-count" style={{fontSize: fontSize}}>{splitNumber('' + props.total)()}</div>
      </div>
      <div className="other-traffic-unique">
        <div className="other-traffic-subtitle">{props.uniqueTitle || 'Unique Other'}</div>
        <div className="blue-count" style={{fontSize: fontSize}}>{splitNumber('' + props.unique)()}</div>
      </div>
      <div className="other-traffic-description">
      {props.discription || 'Other traffic includes traffic derived from wireless, proxy, foreign, bots and other non-routable traffic'}
      </div>
    </div>
  </div>)
}


// WEBPACK FOOTER //
// ./src/components/Insights/summary/OtherTraffic.jsx